import type { ReactElement } from 'react';

import styles from './BingoCard.module.css';

// import { default as FullHouseAr } from './assets/fullhouse/fullhouse_ar.png';

interface BingoCardProps {
  info: any;
  multipliers: Record<string, number>;
}

export function BingoCard({ info, multipliers }: BingoCardProps): ReactElement {
  // const currentLanguage: string = useSettingsSlice.currentLanguage();

  const almostContent = info.markedContent.map((row: number[], rowIndex: number) =>
    row.map((column: number, colIndex: number) => {
      if (column == -1) {
        return false;
      }

      // Check Horizontal
      if (row[1 >> colIndex] == -1 && row[2 - (colIndex >> 1)] == -1) {
        return true;
      }

      // Check Vertical
      return (
        info.markedContent[1 >> rowIndex][colIndex] == -1 && info.markedContent[2 - (rowIndex >> 1)][colIndex] == -1
      );
    })
  );

  return (
    <div className={styles.BingoCard}>
      <div className={styles.title}>{info.multiplier ? info.multiplier + 'x' : ''}</div>
      <div className={styles.marks}>
        <div className={styles.mark}>
          <div className={`${styles.rect} ${styles.green}`} />
        </div>
        <div className={styles.mark}>
          <div className={`${styles.rect} ${styles.white}`} />
        </div>
        <div className={styles.mark}>
          <div className={`${styles.rect} ${styles.yellow}`} />
        </div>
      </div>
      <div className={styles.content}>
        {info.content.map((contentRow: number[], rowIndex: number) => (
          <div key={rowIndex} className={styles.row}>
            {contentRow.map((column: number, colIndex: number) => (
              <div
                key={colIndex}
                className={`${styles.column} ${almostContent[rowIndex][colIndex] ? styles.almost : ''} ${
                  info.markedContent[rowIndex][colIndex] ? styles.out : ''
                } ${
                  multipliers[column] ? styles.marked : ''
                }`}
              >
                {column}
                {multipliers[column] > 2 ? <div className={styles.multiplier}>{multipliers[column]}x</div> : null}
              </div>
            ))}
          </div>
        ))}
        {info.strikes.map((strike: string) => (
          <div
            key={strike}
            className={`${styles.strike} ${styles[strike.split('')[0]]} ${styles['P' + strike.split('')[1]]}`}
          />
        ))}
      </div>
    </div>
  );
}
